import React from 'react';
/* eslint-disable */
export const IntermediateDifficulty = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="45"
    width="84"
    viewBox="0 0 84 45"
    className="difficulty"
    data-testid="svg-intermediate-difficulty"
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M23 38v-.528c-.145-8.568 6.57-15.633 15-15.783 8.43.15 15.145 7.215 15 15.783V38h13v-.528C66 21.212 53.46 8 38 8S10 21.211 10 37.472V38h13z"
      />
      <path
        fill="#F26422"
        d="M37.75 20.76V7.31c-15.46 0-29 12.49-29 28.5 0 .17 1 .82 1 1h13v-.52c-.145-8.43 6.57-15.382 15-15.53z"
      />
      <path
        fill="#333"
        d="M37.75 7.81c15.464 0 28 12.536 28 28H53.5c0-8.698-7.052-15.75-15.75-15.75S22 27.112 22 35.81H9.75c0-15.464 12.536-28 28-28zm0-1.75C21.326 6.077 8.017 19.386 8 35.81v1.75h15.75v-1.75c0-7.732 6.268-14 14-14s14 6.268 14 14v1.75H67.5v-1.75C67.483 19.386 54.174 6.077 37.75 6.06z"
      />
      <path
        fill="#333"
        d="M36 37.81h3.52L37.76.42V.16c0-.08-.06-.21-.09 0-.01.09-.01.18 0 .27v.79l-.08 2-.21 4.3-.19 4.38-.2 4.66-.21 4.7-.2 4.52-.18 4.11-.16 3.48-.17 2.63-.07 1.5v.31z"
      />
    </g>
  </svg>
);
